import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {useDispatch, useSelector} from 'react-redux';
import {useInflight} from 'src/hooks/redux';

import {useApi} from 'src/hooks/useApi';

import {formatMomentDateWithFormat} from 'src/utils/date-time';

import * as reduxApi from 'src/utils/redux-api-v2';

import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from '@spaced-out/ui-design-system/lib/components/Panel';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';

import {Shimmer} from '@spaced-out/ui-design-system/lib/components/Shimmer';

import {
  Toast,
  TOAST_SEMANTIC,
  toastApi,
  ToastTitle,
} from '@spaced-out/ui-design-system/lib/components/Toast';

import {
  Card,
  CardHeader,
  CardTitle,
  CardActions,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';

import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from '@spaced-out/ui-design-system/lib/components/Dialog';

import {
  ButtonTextMedium,
  BodyMedium,
  BodyLarge,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';

import {ButtonDropdown} from '@spaced-out/ui-design-system/lib/components/ButtonDropdown';

import {
  getJobScoreCards,
  getScoreCardConfig,
  getFeedbackConfiguration,
  deleteInterviewReview,
  deleteEvaluationFormDraft,
} from 'src/action-creators/crm';
import {
  selectJobScoreCards,
  selectJobScoreCardConfig,
  selectFeedbackConfiguration,
  selectUserInfo,
} from 'src/selectors/crm';

import GetSpecficSections from './get-specific-sections';

import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {Link} from '@spaced-out/ui-design-system/lib/components/Link';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';
import EvaluationFormView from './evaluation-form-view';
import EvaluationFormEdit from './evaluation-form-edit';

import css from './single-evaluation.css';


const SingleEvaluation = ({
  // @ts-expect-error - TS7031 - Binding element 'review' implicitly has an 'any' type.
  review,
  // @ts-expect-error - TS7031 - Binding element 'stepCandidate' implicitly has an 'any' type.
  stepCandidate,
  // @ts-expect-error - TS7031 - Binding element 'stage' implicitly has an 'any' type.
  stage,
  // @ts-expect-error - TS7031 - Binding element 'scorecard' implicitly has an 'any' type.
  scorecard,
  // @ts-expect-error - TS7031 - Binding element 'scorecardConfigData' implicitly has an 'any' type.
  scorecardConfigData,
  hideDelete = false,
  // @ts-expect-error - TS7031 - Binding element 'jobId' implicitly has an 'any' type.
  jobId,
  // @ts-expect-error - TS7031 - Binding element 'onUpdate' implicitly has an 'any' type.
  onUpdate,
}) => {
  const {t, language} = useLabelTranslation();

  const dispatch = useDispatch();
  const [viewModal, setViewModal] = React.useState(false);
  const [editModal, setEditModal] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const isFeedbackConfigurationLoading = useInflight(
    getFeedbackConfiguration(),
  );
  const feedbackConfiguration = useSelector(selectFeedbackConfiguration);

  const isJobScorecardLoading = useInflight(getJobScoreCards(jobId));
  const jobScorecard = useSelector(selectJobScoreCards);
  const {user: userInfo} = useSelector(selectUserInfo) ?? {};

  const {result: stepData, isLoading: isStepDataLoading} = useApi(
    {pathname: `/job-steps/${stepCandidate.stepId}`},
    {
      method: 'GET',
      apiPath: '/trmapi/api',
    },
  );

  const {
    result: scorecardStepConfiguration,
    isLoading: isScorecardStepConfigurationLoading,
  } = useApi(
    {pathname: `/step-scorecard-config?stepId=${stepCandidate.stepId}`},
    {
      method: 'GET',
      apiPath: '/trmapi/api',
    },
  );

  React.useEffect(() => {
    if (!scorecard) {
      dispatch(getJobScoreCards(jobId));
    }
    if (!feedbackConfiguration) {
      dispatch(getFeedbackConfiguration());
    }
  }, [jobId]);

  if (
    isStepDataLoading ||
    isFeedbackConfigurationLoading ||
    isScorecardStepConfigurationLoading ||
    isJobScorecardLoading ||
    !stepData
  ) {
    return <Shimmer width="100%" height="100px" />;
  }

  // @ts-expect-error - TS2339 - Property 'hideScorecard' does not exist on type '{}'. | TS2339 - Property 'hideOverallRecommendation' does not exist on type '{}'.
  const {hideScorecard, hideOverallRecommendation} = stepData || {};
  const {sections: scorecardJobSections} = scorecard || jobScorecard;
  const scorecardStepSections = scorecardJobSections
    // @ts-expect-error - TS7006 - Parameter 'section' implicitly has an 'any' type.
    .map((section) => {
      // @ts-expect-error - TS2339 - Property 'find' does not exist on type '{}'.
      const foundStepSection = scorecardStepConfiguration?.find(
        (stepSection: any) => stepSection.sectionId === section.id,
      );

      return {
        ...section,
        status: foundStepSection ? foundStepSection.status : '',
      };
    })
    // @ts-expect-error - TS7006 - Parameter 's' implicitly has an 'any' type.
    .filter((s) => s.status !== 'RESTRICTED');

  const feedbackActions = [
    ...(review.reviewer && review.reviewer?.id === userInfo?.id
      ? [
          {
            key: 'edit',
            label: t('Edit', 'Edit'),
          },
        ]
      : []),
    ...(review &&
    review.reviewer &&
    (review.reviewer?.id === userInfo?.id || review.updatedBy === userInfo?.id)
      ? [
          {
            key: 'delete',
            label: t('Delete', 'Delete'),
          },
        ]
      : []),
  ];

  const deleteFeedback = async () => {
    setIsLoading(true);
    await dispatch(deleteInterviewReview(review.id))
      .then(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>
              {t(
                'Feedback_deleted_successfully',
                'Feedback deleted successfully',
              )}
            </ToastTitle>
          </Toast>,
        );
        setIsLoading(false);
        onUpdate?.();
      })
      .catch(() => {
        setIsLoading(false);
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {t('Unable_to_delete_feedback', 'Unable to delete feedback')}
            </ToastTitle>
          </Toast>,
        );
      })
      .finally(() => {
        setIsDeleteDialogOpen(false);
      });
  };

  const handleSubmitForm = (evaluation: any) => {
    const {jobId, stageId, stepId, candidateId} = stepCandidate;

    const newValues = {
      jobId,
      stageId,
      stepId,
      candidateId,
      ...evaluation,
      reviewerId: userInfo.id,
      interviewCandidateId: stepCandidate.id,
    } as const;

    if (hideScorecard) {
      delete newValues.feedbackScores;
    }
    if (hideOverallRecommendation) {
      delete newValues.reviewStatus;
      delete newValues.comment;
    }

    setIsSubmitting(true);

    dispatch(
      reduxApi.post(
        `api/interview-reviews/${review.id}`,
        {
          ...newValues,
        },
        {},
        {apiPath: '/trmapi/'},
      ),
    )
      .then(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>{`${t(
              'Feedback_Updated_Successfully',
              'Feedback Updated Successfully',
            )}!`}</ToastTitle>
          </Toast>,
        );
        onUpdate?.();
        setEditModal(false);
        setViewModal(true);
        dispatch(
          deleteEvaluationFormDraft(`${stepCandidate.id}~${userInfo.id}`),
        );
      })
      .catch((error) => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>{`${t(
              'Feedback_Update_Failed',
              'Feedback Update Failed',
            )}!`}</ToastTitle>
          </Toast>,
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const getAverageScore = (feedbackScores: any) => {
    if (!feedbackScores) {
      return t('NA', 'N/A');
    }
    const {totalScore, count} = feedbackScores.reduce(
      // @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'current' implicitly has an 'any' type.
      (result, current) => {
        return {
          count: current.score > 0 ? result.count + 1 : result.count,
          totalScore: result.totalScore + current.score,
        };
      },
      {
        count: 0,
        totalScore: 0,
      },
    );
    const averageScore = totalScore / count;
    return count === 0 ? t('NA', 'N/A') : averageScore.toPrecision(2);
  };

  return (
    <Card
      classNames={{
        wrapper: css.card,
      }}
    >
      <CardHeader>
        <CardTitle>
          <ButtonTextMedium color="clickable">
            {stage && stage?.name ? stage.name : ''}
            {/* @ts-expect-error - TS2339 - Property 'name' does not exist on type '{}'. | TS2339 - Property 'name' does not exist on type '{}'. */}
            {stepData && stepData?.name ? ` - ${stepData.name}` : ''}
          </ButtonTextMedium>
        </CardTitle>
        <CardActions>
          <Button
            type="tertiary"
            size="small"
            onClick={() => {
              setViewModal(true);
            }}
          >
            {t('View_Feedback', 'View Feedback')}
          </Button>
          {feedbackActions.length > 0 ? (
            <ButtonDropdown
              iconRightName="ellipsis-vertical"
              menu={{
                isFluid: false,
                menuDisabled: false,
                options: feedbackActions,
                size: 'small',
              }}
              onOptionSelect={(e) => {
                if (e.key === 'edit') {
                  setEditModal(true);
                }
                if (e.key === 'delete') {
                  setIsDeleteDialogOpen(true);
                }
              }}
              size="small"
              type="tertiary"
            />
          ) : null}
        </CardActions>
      </CardHeader>
      <CardContent className={css.stepCandidateFeedbackCardContent}>
        <div className={css.stepCandidateFeedbackDataRow}>
          <BodyMedium>
            {review?.platform
              ? t('Submitted_by_candidate', 'Submitted by candidate')
              : review?.reviewer && review.reviewer.fullName
              ? `${t('Interviewed_by', 'Interviewed by')}: ${
                  review.reviewer.fullName
                }`
              : ''}
          </BodyMedium>
          {!hideOverallRecommendation ? (
            <BodyMedium>
              {review?.platform
                ? `${t('Test_Percentage', 'Test Percentage')} - ${
                    review?.percentage
                  }%`
                : `${t('Overall_Recommendation', 'Overall Recommendation')} - ${
                    review?.reviewStatus ?? '-'
                  }`}
            </BodyMedium>
          ) : null}
        </div>
        <div className={css.stepCandidateFeedbackDataRow}>
          <BodyMedium>
            {`${t('Date', 'Date')}: ${formatMomentDateWithFormat(
              review?.updatedOn,
              'YYYY-MM-DD',
              language,
            )}`}
          </BodyMedium>
          {!hideOverallRecommendation ? (
            <BodyMedium>
              {review?.platform
                ? `${t('Candidate_Score', 'Candidate Score')} - ${
                    review?.score
                  } / ${review?.totalScore}`
                : `${t('Average_Score', 'Average Score')} - ${getAverageScore(
                    review.feedbackScores,
                  )}`}
            </BodyMedium>
          ) : null}
        </div>
      </CardContent>
      {viewModal ? (
        <Panel
          isOpen={viewModal}
          onClose={() => setViewModal(false)}
          anchor="right"
          size="large"
          hideBackdrop={false}
        >
          <PanelHeader onCloseButtonClick={() => setViewModal(false)}>
            {t('View_Feedback', 'View Feedback')}
          </PanelHeader>
          <GetSpecficSections
            jobId={jobId}
            stageId={stepCandidate.stageId}
            stepId={stepCandidate.stepId}
            loaderComponent={
              <PanelBody className={css.panelBody}>
                <div className={css.loaderContainer}>
                  <CircularLoader />
                </div>
              </PanelBody>
            }
          >
            {(sections) => (
              <PanelBody className={css.panelBody}>
                <EvaluationFormView
                  // @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'JobStageStep': id, createdBy, createdOn, updatedBy, and 20 more.
                  step={stepData}
                  feedbackConfiguration={feedbackConfiguration}
                  scorecardStepSections={scorecardStepSections}
                  subjectiveSections={sections}
                  review={review}
                />

                <DeleteReviewDialog
                  isOpen={isDeleteDialogOpen}
                  setIsOpen={setIsDeleteDialogOpen}
                  onConfirm={() => {
                    deleteFeedback();
                  }}
                  isLoading={isLoading}
                />
              </PanelBody>
            )}
          </GetSpecficSections>
          <PanelFooter classNames={{actions: css.panelFooterActions}}>
            {review.reviewer && review.reviewer.id === userInfo.id ? (
              <SemanticIcon
                name="trash"
                onClick={() => setIsDeleteDialogOpen(true)}
                semantic="danger"
                className={css.deleteButton}
              />
            ) : null}
            <div className={css.panelFooterActionsRight}>
              <Button
                isFluid
                onClick={() => setViewModal(false)}
                type="tertiary"
              >
                {t('Close', 'Close')}
              </Button>
              {review.reviewer && review.reviewer.id === userInfo.id ? (
                <Button
                  isFluid
                  onClick={() => setEditModal(true)}
                  type="primary"
                >
                  {t('Edit', 'Edit')}
                </Button>
              ) : null}
            </div>
          </PanelFooter>
        </Panel>
      ) : null}

      {editModal ? (
        <Panel
          isOpen={editModal}
          onClose={() => setEditModal(false)}
          anchor="right"
          size="large"
          hideBackdrop={false}
        >
          <PanelHeader onCloseButtonClick={() => setEditModal(false)}>
            {t('Edit_Feedback', 'Edit Feedback')}
          </PanelHeader>
          <PanelBody className={css.panelBodyWithoutPadding}>
            <GetSpecficSections
              jobId={jobId}
              stageId={stepCandidate.stageId}
              stepId={stepCandidate.stepId}
              loaderComponent={
                <PanelBody className={css.panelBody}>
                  <div className={css.loaderContainer}>
                    <CircularLoader />
                  </div>
                </PanelBody>
              }
            >
              {(sections) => (
                // @ts-expect-error - TS2739 - Type '{ step: {}; feedbackConfiguration: FEEDBACK_CONFIG_RESPONSE; scorecardStepSections: any; subjectiveSections: STEP_QUESTIONNAIRE_SECTIONS_RESPONSE[]; ... 6 more ...; alreadyInPanelBody: boolean; }' is missing the following properties from type '{ scorecardStepSections: any; subjectiveSections: any; feedbackConfiguration: any; review: any; step: any; stepCandidateId: any; token: any; tokenId: any; onBehalfOfUserId: any; alreadyInPanelBody: any; onSubmit: any; onCancel: any; isSubmitting: any; }': token, tokenId
                <EvaluationFormEdit
                  step={stepData}
                  feedbackConfiguration={feedbackConfiguration}
                  scorecardStepSections={scorecardStepSections}
                  subjectiveSections={sections}
                  review={review}
                  stepCandidateId={stepCandidate.id}
                  onSubmit={handleSubmitForm}
                  onCancel={() => setEditModal(false)}
                  isSubmitting={isSubmitting}
                  onBehalfOfUserId={review.reviewer?.id}
                  alreadyInPanelBody={true}
                />
              )}
            </GetSpecficSections>
          </PanelBody>
        </Panel>
      ) : null}

      {isDeleteDialogOpen && (
        <DeleteReviewDialog
          isOpen={isDeleteDialogOpen}
          setIsOpen={setIsDeleteDialogOpen}
          onConfirm={() => {
            deleteFeedback();
          }}
          isLoading={isLoading}
        />
      )}
    </Card>
  );
};

export default SingleEvaluation;

const DeleteReviewDialog = ({
  isOpen,
  setIsOpen,
  onConfirm,
  isLoading,
}: {
  isOpen: boolean;
  setIsOpen: (arg1: ((arg1: boolean) => boolean) | boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
}) => {
  const {t} = useLabelTranslation();

  return (
    <Dialog semantic="danger" isOpen={isOpen}>
      <DialogHeader>
        <SubTitleLarge>
          {t('Delete_this_Feedback', 'Delete this Feedback')}
        </SubTitleLarge>
      </DialogHeader>
      <DialogBody>
        <BodyLarge color="secondary">
          {t(
            'Are_you_sure_you_want_to_continue',
            'Are you sure you want to continue',
          )}
          ?
        </BodyLarge>
      </DialogBody>
      <DialogFooter>
        <Button isFluid onClick={() => setIsOpen(false)} type="tertiary">
          {t('No', 'No')}
        </Button>

        <Button isFluid onClick={onConfirm} isLoading={isLoading}>
          {t('Yes_Delete', 'Yes, Delete')}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
